import * as React from 'react';

import { useServicesContext } from '~/providers/services-context';

import { comp } from '../betslip/util/utils';

import BookieFallback from './icons/BookieFallback';
// Styles
import styles from './bookie-logo.module.css';

export enum LOGO_SIZE {
  LARGE = 'large',
  SMALL = 'small',
}

export interface IProps {
  bookieCode: string;
  className?: string;
  noPadding?: boolean;
  onClick?: () => void;
  size: LOGO_SIZE;
  testId?: string;
  withBackground?: boolean;
}

const BookieLogo: React.FC<IProps> = ({
  bookieCode,
  className = '',
  noPadding = false,
  onClick,
  size,
  testId = 'bookie-logo',
  withBackground = true
}) => {
  const [error, setError] = React.useState(false);

  const {
    siteConfig: { bookmakers }
  } = useServicesContext();

  const bookie = bookmakers?.[`${bookieCode}`];
  const logoUrl = size === 'large' ? bookie?.logoLarge : bookie?.logoSmall;
  const canRenderBookieLogo = bookie?.brandColour && logoUrl;

  if (error || !canRenderBookieLogo) {
    const width = size === 'large' ? 190 : 40;
    const height = size === 'large' ? 50 : 40;

    return (
      <BookieFallback
        className={comp(
          styles.bookieLogo,
          noPadding ? styles.noPadding : '',
          className
        )}
        height={height}
        width={width} />);


  }

  return (
    <img
      alt={`${bookie?.bookmakerName} logo`}
      className={comp(
        styles.bookieLogo,
        noPadding ? styles.noPadding : '',
        className
      )}
      data-testid={testId}
      onClick={onClick}
      onError={() => {
        setError(true);
      }}
      src={logoUrl}
      style={{ background: withBackground ? bookie?.brandColour : '' }} />);


};

export default BookieLogo;